import React, { Fragment, useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import {
  Badge,
  Button,
  Card,
  CardBody,
  DropdownMenu,
  DropdownToggle,
  Input,
  DropdownItem,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  UncontrolledDropdown,
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import {
  AxiosAPI,
  getGroupID,
  getUserID,
} from '../../../../../../helpers/AxiosAPI';
import { connect } from 'react-redux';
import { gAPI_Publish_logs } from '../../../../../../constants/APIs';
import moment from 'moment';
import Pagination from '../../../../../../containers/pages/Pagination';
import IntlMessages from '../../../../../../helpers/IntlMessages';
function generateRandomColor() {
  var arr = [
    'primary',
    'secondary',
    'info',
    'success',
    'warning',
    'danger',
    'light',
    'dark',
  ];
  return arr[Math.floor(Math.random() * arr.length)];
}

function Logs({ logType, propertyId }) {
  const [logList, setLogList] = useState([]);
  const [pageSizes, setpageSizes] = useState([10, 15, 20, 25]);
  const [currentPage, setcurrentPage] = useState(1);
  const [SelectedPageSize, setSelectedPageSize] = useState(10);
  const startIndex = (currentPage - 1) * SelectedPageSize;
  const endIndex = currentPage * SelectedPageSize;
  const [TotalItems, setTotalItems] = useState(0);
  const [TotalPages, setTotalPages] = useState(1);

  const changePageSize = (size) => {
    setSelectedPageSize(size);
    setcurrentPage(1);
  };

  useEffect(() => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Publish_logs}?groupId=${getGroupID()}&propertyId=${propertyId}&type=${logType}&pageNumber=${currentPage}&pageSize=${SelectedPageSize}`,
    }).then((res) => {
      setTotalItems(res.data.totalItems);
      setTotalPages(res.data.totalPages);
      setLogList(res.data.logs);
    });
  }, [propertyId, currentPage, SelectedPageSize]);

  const onChangePage = (page) => {
    setcurrentPage(page);
  };

  return (
    <Fragment>
      <Row className="">
        <Colxx xxs="12" className="mb-3">
          <div className="float-md-right">
            <span className="text-muted text-small mr-1">{`${startIndex}-${endIndex} of ${TotalItems} `}</span>
            <UncontrolledDropdown className="d-inline-block">
              <DropdownToggle caret color="outline-dark" size="xs">
                {SelectedPageSize}
              </DropdownToggle>
              <DropdownMenu right>
                {pageSizes.map((size, index) => {
                  return (
                    <DropdownItem
                      key={index}
                      onClick={() => changePageSize(size)}
                    >
                      {size}
                    </DropdownItem>
                  );
                })}
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
        </Colxx>
        <Colxx xxs="12">
          {logList !== undefined &&
            logList.length > 0 &&
            logList.map((m, index) => (
              <Row className="mb-3">
                <Colxx xxs="12">
                  <Card
                    className="d-flex mb-3"
                    key={`faqItem_${index}`}
                    style={{ borderRadius: '20px' }}
                  >
                    <CardBody>
                      <Row className="mb-2 text-left">
                        <Colxx xxs="2" className="mb-2">
                          {m.content?.type}
                        </Colxx>
                        <Colxx xxs="3" className="mb-2">
                          {m.action}
                        </Colxx>
                        <Colxx xxs="3" className="mb-2">
                          <IntlMessages id='dashboards.published' /> at {moment(m.date).format('LLL')}
                        </Colxx>
                        <Colxx xxs="2" className="mb-2">
                          {m.content?.includedItems}
                        </Colxx>
                        <Colxx xxs="2" className="mb-2 text-right">
                          <Badge className="mb-1" color="outline-primary" pill>
                            {m.content?.status && m.content.status}
                          </Badge>{' '}
                        </Colxx>
                      </Row>
                    </CardBody>
                  </Card>
                </Colxx>
              </Row>
            ))}
        </Colxx>
      </Row>
    </Fragment>
  );
}
const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId,
    locale,
  };
};

export default injectIntl(connect(mapStateToProps, {})(Logs));
